import React from 'react';
import { Row, Col, Card } from 'react-bootstrap';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

const rooms = [
  { id: 1, image: "/images/rooms/ro1.jpg", price: "$55.00", title: "Deluxe Room" },
  { id: 2, image: "/images/rooms/ro2.jpg", price: "$65.00", title: "Executive Suite" },
  { id: 3, image: "/images/rooms/ro3.jpg", price: "$45.00", title: "Standard Room" },
  { id: 4, image: "/images/rooms/ro4.jpg", price: "$75.00", title: "Premium Suite" },
  { id: 5, image: "/images/rooms/ro5.jpg", price: "$85.00", title: "Family Room" },
  { id: 6, image: "/images/rooms/ro6.jpg", price: "$95.00", title: "Presidential Suite" },
];

export default function RoomsGrid() {
  return (
    <Row className="g-4 mb-5">
      {rooms.map((room, index) => (
        <Col key={room.id} md={6} lg={4}>
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: index * 0.1 }}
          >
            <Card className="shadow h-100 border-0">
                <div className='overflow-hidden rounded-top'>
                    <Card.Img
                variant="top"
                src={room.image}
                alt={room.title}
                style={{ height: '200px', objectFit: 'cover' }}
              />
                </div>
              
              <Card.Body className="text-center bg-light">
                <Card.Text className='mb-0'>
                    <Link to={'/'} className='fs-3 text-primary opacity-50 fw-bold text-decoration-none'>{room.title}</Link>
                </Card.Text>
                <Card.Title className='fw-bold mt-0 text-primary'>{room.price} / Night</Card.Title>
              </Card.Body>
            </Card>
          </motion.div>
        </Col>
      ))}
    </Row>
  );
}
